function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { API_URL } from '../../utils/constant';
import { assetPath, translate, translateFieldName, cleanHTML } from '../../utils/helpers';
import _orderBy from 'lodash/orderBy';
import _deburr from 'lodash/deburr';
import _compact from 'lodash/compact';
import striptags from 'striptags';

var SingleProductMobileAccordion = /*#__PURE__*/function (_Component) {
  _inherits(SingleProductMobileAccordion, _Component);

  var _super = _createSuper(SingleProductMobileAccordion);

  function SingleProductMobileAccordion() {
    _classCallCheck(this, SingleProductMobileAccordion);

    return _super.apply(this, arguments);
  }

  _createClass(SingleProductMobileAccordion, [{
    key: "render",
    value: function render() {
      var product = this.props.product;
      return /*#__PURE__*/React.createElement("div", {
        className: "mobile-display d-block d-sm-block d-md-none"
      }, product[translateFieldName('description')] !== null ? /*#__PURE__*/React.createElement("div", {
        className: "description-box mb-detailbox mobile-center",
        "data-toggle": "collapse",
        "data-target": "#collapseDescription",
        "aria-expanded": "true",
        "aria-controls": "collapseDescription"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "first-uppercase title mobile-center"
      }, translate('full description', 'description complète')), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-up fa-2x text-center",
        "aria-hidden": "true"
      })), /*#__PURE__*/React.createElement("div", {
        className: "first-uppercase collapse show",
        id: "collapseDescription"
      }, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: cleanHTML(product[translateFieldName('description')])
        }
      }), product.pictos.length ? /*#__PURE__*/React.createElement("div", null, product.pictos.map(function (picto) {
        return picto[translateFieldName('description')] !== null ? /*#__PURE__*/React.createElement("img", {
          className: "pictos-box",
          key: picto.id,
          src: assetPath(picto.picto.url),
          alt: picto[translateFieldName('name')],
          title: picto[translateFieldName('description')].replace(new RegExp('<br />', 'g'), ' ')
        }) : /*#__PURE__*/React.createElement("img", {
          className: "pictos-box",
          key: picto.id,
          src: assetPath(picto.picto.url),
          alt: picto[translateFieldName('name')]
        });
      })) : null)) : null, product.product_characteristics.length ? /*#__PURE__*/React.createElement("div", {
        className: "characteristics-box mb-detailbox mobile-center collapsed second-border",
        "data-toggle": "collapse",
        "data-target": "#collapseFeatures",
        "aria-expanded": "false",
        "aria-controls": "collapseFeatures"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "first-uppercase title"
      }, translate('Characteristics', 'Caractéristiques')), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-up fa-2x text-center",
        "aria-hidden": "true"
      })), /*#__PURE__*/React.createElement("div", {
        className: "items-list collapse",
        id: "collapseFeatures"
      }, _orderBy(product.product_characteristics, [function (characteristic) {
        return _deburr(characteristic.characteristic[translateFieldName('name')].toLowerCase());
      }]).map(function (characteristic) {
        return characteristic.characteristic[translateFieldName('name')] !== '' && characteristic[translateFieldName('value')] !== '' ? /*#__PURE__*/React.createElement("div", {
          key: characteristic.id,
          className: "item-features"
        }, /*#__PURE__*/React.createElement("div", {
          className: "second-bg-after"
        }, characteristic.characteristic[translateFieldName('name')]), /*#__PURE__*/React.createElement("span", null, characteristic[translateFieldName('value')])) : null;
      }))) : null, product[translateFieldName('note')] !== null && product[translateFieldName('note_title')] !== '' ? /*#__PURE__*/React.createElement("div", {
        className: "dilution-box mb-detailbox mobile-center collapsed second-border",
        "data-toggle": "collapse",
        "data-target": "#collapseDilution",
        "aria-expanded": "false",
        "aria-controls": "collapseDilution"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "first-uppercase title"
      }, product[translateFieldName('note_title')]), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-up fa-2x text-center",
        "aria-hidden": "true"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "items-list collapse",
        id: "collapseDilution"
      }, _compact(striptags(product[translateFieldName('note')], [], '&lt;br /&gt;').split('&lt;br /&gt;')).map(function (note) {
        return /*#__PURE__*/React.createElement("li", {
          className: "d-flex align-items-center main-after",
          key: note
        }, /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: note
          }
        }));
      }))) : null, product[translateFieldName('notifications')] ? /*#__PURE__*/React.createElement("div", {
        className: "mb-detailbox mobile-center collapsed second-border",
        "data-toggle": "collapse",
        "data-target": "#collapseNotifications",
        "aria-expanded": "false",
        "aria-controls": "collapseNotifications"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "first-uppercase title"
      }, translate('advantages', 'avantages')), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-up fa-2x text-center",
        "aria-hidden": "true"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "items-list collapse",
        id: "collapseNotifications"
      }, _compact(striptags(product[translateFieldName('notifications')], [], '&lt;br /&gt;').split('&lt;br /&gt;')).map(function (notification) {
        return /*#__PURE__*/React.createElement("li", {
          className: "d-flex align-items-center main-after",
          key: notification
        }, /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: notification
          }
        }));
      }))) : null, product[translateFieldName('product_file')].url || product[translateFieldName('other_pdf_name')] || product[translateFieldName('other_pdf_name2')] ? /*#__PURE__*/React.createElement("div", {
        className: "mb-detailbox documents-box mobile-center collapsed second-border",
        "data-toggle": "collapse",
        "data-target": "#collapseDocuments",
        "aria-expanded": "false",
        "aria-controls": "collapseDocuments"
      }, /*#__PURE__*/React.createElement("div", {
        className: ""
      }, /*#__PURE__*/React.createElement("p", {
        className: "first-uppercase title "
      }, translate('Description documents', 'Documents descriptifs')), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-up fa-2x text-center",
        "aria-hidden": "true"
      })), /*#__PURE__*/React.createElement("div", {
        className: " collapse",
        id: "collapseDocuments"
      }, product[translateFieldName('product_file')].url ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-file-pdf-o fa-fw main-txt different",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("a", {
        href: API_URL + product[translateFieldName('product_file')].url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React.createElement("span", {
        className: "main-txt"
      }, translate('Product sheet', 'Fiche produit')))) : null, product[translateFieldName('other_pdf')].url ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-file-pdf-o fa-fw main-txt",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("a", {
        href: API_URL + product[translateFieldName('other_pdf')].url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React.createElement("span", {
        className: "main-txt"
      }, product[translateFieldName('pdf_name')]))) : null, product[translateFieldName('other_pdf2')].url ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-file-pdf-o fa-fw main-txt",
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement("a", {
        href: API_URL + product[translateFieldName('other_pdf2')].url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React.createElement("span", {
        className: "main-txt"
      }, product[translateFieldName('other_pdf_name2')]))) : null)) : null);
    }
  }]);

  return SingleProductMobileAccordion;
}(Component);

SingleProductMobileAccordion.propTypes = {
  product: PropTypes.object
};
export default SingleProductMobileAccordion;